import React, { useContext, useEffect, useState } from "react";

import { SalesContext } from "../../context/salesContext";
import { StatCard } from "../ui";

const WorkOrderStats = () => {
    const { action } = useContext(SalesContext);
    const [stats, setStats] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const data = await action.getStats();
            if (cancelled || !data || typeof data !== "object" || Array.isArray(data)) return;
            setStats({
                overdue: data.overdue || 0,
                pending: data.pending || 0,
                doors: data.doors || 0,
                ready: data.ready || 0,
            });
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const v = (key) => (stats ? stats[key] : "—");

    return (
        <section
            aria-label="Work order summary"
            className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4"
        >
            <StatCard
                tone="danger"
                label="Overdue"
                value={v("overdue")}
                icon={<i className="fas fa-exclamation-circle" />}
                hint="Past expected completion"
            />
            <StatCard
                tone="warning"
                label="Pending"
                value={v("pending")}
                icon={<i className="fas fa-ellipsis-h" />}
                hint="Awaiting parts or paint"
            />
            <StatCard
                tone="info"
                label="In Progress"
                value={v("doors")}
                icon={<i className="fas fa-tasks" />}
                hint="Prep and door builds"
            />
            <StatCard
                tone="success"
                label="Ready"
                value={v("ready")}
                icon={<i className="fas fa-thumbs-up" />}
                hint="Pickup or installation"
            />
        </section>
    );
};

export default WorkOrderStats;
